import { selectors as streamSelectors } from '../../Stream';
import { watchedGroupsStreamId, recommendedGroupsStreamId, reduxKey } from './constants';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { getDataEntitiesByIds } from '../../redux/entities/selectors';
import { userSchema } from '../../redux/normalizr/schemas/user';
function getNetworkBarState(state) {
    var _state_reduxKey;
    return (_state_reduxKey = state[reduxKey]) !== null && _state_reduxKey !== void 0 ? _state_reduxKey : {
        isInitialized: false,
        mainNavItems: []
    };
}
export function getIsNetworkBarInitialized(state) {
    return getNetworkBarState(state).isInitialized;
}
export function isNetworkBarLoading(state) {
    return !streamSelectors.isInitialized(state, watchedGroupsStreamId) || !streamSelectors.isInitialized(state, recommendedGroupsStreamId) || streamSelectors.isFetching(state, watchedGroupsStreamId) || streamSelectors.isFetching(state, recommendedGroupsStreamId);
}
export function getCanUserHaveWatchedGroups(state) {
    return getIsLoggedIn(state) && (streamSelectors.getItems(state, watchedGroupsStreamId).length > 0 || streamSelectors.isFetching(state, watchedGroupsStreamId) || streamSelectors.hasMore(state, watchedGroupsStreamId));
}
export function getCanUserHaveRecommendedGroups(state) {
    return getIsLoggedIn(state) && (streamSelectors.getItems(state, recommendedGroupsStreamId).length > 0 || streamSelectors.isFetching(state, recommendedGroupsStreamId) || streamSelectors.hasMore(state, recommendedGroupsStreamId));
}
export function getMainNavItems(state) {
    return getNetworkBarState(state).mainNavigation;
}
export function getIsSectionFolded(state, section) {
    return getNetworkBarState(state).sections[section].isFolded;
}
export function getHasUnreadContent(state) {
    var _watchedGroupIds;
    // TODO: in theory backend will return us a convenient flag soon
    if (getMainNavItems(state).some((item)=>item.hasNewContent)) {
        return true;
    }
    const watchedGroupIds = streamSelectors.getItems(state, watchedGroupsStreamId);
    if (!((_watchedGroupIds = watchedGroupIds) === null || _watchedGroupIds === void 0 ? void 0 : _watchedGroupIds.length)) {
        return false;
    }
    const watchedGroups = getDataEntitiesByIds(state, userSchema, watchedGroupIds);
    return watchedGroups.some((group)=>{
        var _group_networkbar;
        return (_group_networkbar = group.networkbar) === null || _group_networkbar === void 0 ? void 0 : _group_networkbar.hasNewContent;
    });
}
